import React from "react";
import pure from "recompose/pure";
import "./Button.css";

export default pure(({ children, ...props }) => (
  <a className="button" {...props}>
    {children}
  </a>
));



// WEBPACK FOOTER //
// ./src/components/Button/Button.js